import { Button, Drawer, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { eventDetailsStyles } from "./EventDetailsStyles";
import EventInfo from "components/EventInfo/EventInfo";
import EventDescription from "components/EventDescription/EventDescription";
import BatchRow from "components/BatchRow/BatchRow";
import { useStore } from "store/StoreConfigs";
import { EventRequest } from "api/thorRequestModels/Events/EventRequest";
import { useHistory, useParams } from "react-router-dom";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import EventAnalysis from "components/EventAnalysis/EventAnalysis";
import { ReactComponent as ChevronLeft } from "icons/ChevronLeft.svg";
import AssignEventMenu from "components/AssignEventMenu/AssignEventMenu";
import UploadArea from "components/UploadArea/UploadArea";
import { EventStatus } from "models/thorEventModels/EventDetails";
import AttachedFilesModal from "components/AttachedFilesModal/AttachedFilesModal";
import EventLevelInformation from "components/EventLevelInformation/EventLevelInformation";

export default observer(function EventDetails() {
    const { thorEventViewStore, identityStore } = useStore();
    const classes = eventDetailsStyles();
    const { eventId } = useParams<any>();

    const history = useHistory();

    const request: EventRequest = {
        customerId: identityStore.currentCustomerId,
        eventId: eventId,
    };

    useEffect(() => {
        thorEventViewStore.loadEventDetails(request);
        thorEventViewStore.getEventSummary(request);
    }, []);

    return (
        <>
            <UploadArea />
            <AttachedFilesModal />
            <Drawer
                anchor="right"
                open={
                    thorEventViewStore.isAssignMenuOpen ||
                    (thorEventViewStore.eventDetails.eventStatusId === EventStatus.PendingApproval &&
                        !thorEventViewStore.eventDetails.qaUserId)
                }
            >
                <AssignEventMenu
                    eventId={thorEventViewStore.eventDetails.eventId}
                    reviewerUserId={thorEventViewStore.eventDetails.reviewerUserId}
                    qaUserId={thorEventViewStore.eventDetails.qaUserId}
                    eventStatusId={thorEventViewStore.eventDetails.eventStatusId}
                />
            </Drawer>

            <main className={classes.content}>
                {thorEventViewStore.isEventDetailsLoaded ||
                thorEventViewStore.isEventSummaryLoaded ||
                thorEventViewStore.isAssessmentSet ||
                thorEventViewStore.isEventClosed ? (
                    <div className={classes.indicatorContainer}>
                        <LoadingIndicator />
                    </div>
                ) : (
                    <>
                        <Button
                            className={classes.backBtn}
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <ChevronLeft />
                            <Typography className={classes.backText}>Back</Typography>
                        </Button>

                        <EventInfo />

                        <EventLevelInformation />

                        <EventDescription />

                        <div className={classes.margin}>
                            <Typography className={classes.title}>Assessment</Typography>
                            <Typography className={classes.text}>
                                Utilizing the conditions and context from above, make an informed analysis of the event.
                            </Typography>
                            {thorEventViewStore.eventDetails.impactedBatches.map((batch) => (
                                <BatchRow key={batch.batchId} batch={batch} />
                            ))}
                        </div>

                        {thorEventViewStore.eventSummary.batchSummaries.some((x) => x.isApproved !== null) && (
                            <EventAnalysis />
                        )}
                    </>
                )}
            </main>
        </>
    );
});
